import { ChatDots } from 'react-bootstrap-icons';

interface ContactUsIconProps {
    clickfunc: () => void;
}

function ContactUsIcon({clickfunc}: ContactUsIconProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            <div className="d-inline-block">
                <ChatDots onClick={clickfunc} size={24} />
            </div>
        </>
    )
}

export default ContactUsIcon;